export const DollarCircleIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5C12.5523 5 13 5.44772 13 6V6.71429H14.8571C15.4094 6.71429 15.8571 7.16201 15.8571 7.71429C15.8571 8.26658 15.4094 8.71429 14.8571 8.71429H13V11H13.4286C14.2473 11 15.0174 11.3491 15.5738 11.9453C16.1281 12.5392 16.4286 13.3307 16.4286 14.1429C16.4286 14.955 16.1281 15.7466 15.5738 16.3404C15.0174 16.9366 14.2473 17.2857 13.4286 17.2857H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V17.2857H8.57141C8.01913 17.2857 7.57141 16.838 7.57141 16.2857C7.57141 15.7334 8.01913 15.2857 8.57141 15.2857H11V13H10.5714C9.75263 13 8.98258 12.6509 8.42614 12.0547C7.87188 11.4608 7.57141 10.6693 7.57141 9.85715C7.57141 9.04502 7.87188 8.25346 8.42614 7.6596C8.98258 7.06342 9.75263 6.71429 10.5714 6.71429H11V6C11 5.44772 11.4477 5 12 5ZM10.5714 8.71429H11V11H10.5714C9.97194 11 9.57141 10.4146 9.57141 9.85715C9.57141 9.29974 9.97194 8.71429 10.5714 8.71429ZM13 15.2857V13H13.4286C14.028 13 14.4286 13.5855 14.4286 14.1429C14.4286 14.7003 14.028 15.2857 13.4286 15.2857H13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        fill="currentColor"
      />
    </svg>
  );
};
